export default __webpack_public_path__ + "static/media/public-merchant-profile-cover.63ae7240.svg";